'use client';

import React, { createContext, useContext } from 'react';

interface SectionContextType {
  sectionId: string | null;
}

const SectionContext = createContext<SectionContextType>({
  sectionId: null
});

export function SectionProvider({ 
  children, 
  sectionId 
}: { 
  children: React.ReactNode; 
  sectionId: string;
}) {
  return (
    <SectionContext.Provider value={{ sectionId }}>
      {children}
    </SectionContext.Provider>
  );
}

export function useSectionId() {
  return useContext(SectionContext).sectionId;
}


















